module.exports = __webpack_public_path__ + "static/media/data_locations.62ac5c06.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/data_locations.png
// module id = 257
// module chunks = 0